import React, { useState, useEffect } from 'react';
import { NavListItem, Tooltip } from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { MdMenu, MdMenuOpen } from 'react-icons/md';
import { MdMenuBook, MdApps, MdVpnKey } from 'react-icons/md';
import useCurrentTab from '../Hooks/useCurrentTab';
import css from './style.css';

const tabs = [
  {
    tabName: 'libTranslations',
    tabLink: '/translations/libTranslations',
    Icon: MdMenuBook,
    shortLabelId: 'ui-translations.sidebar.libTranslations.shortLabel',
    shortLabelDefault: 'Library Vocabs',
    descriptionId: 'ui-translations.sidebar.libTranslations.description',
    descriptionDefault: 'Manage library vocabulary Translations',
  },
  {
    tabName: 'stripesApps',
    tabLink: '/translations/stripesApps',
    Icon: MdApps,
    shortLabelId: 'ui-translations.sidebar.stripesApps.shortLabel',
    shortLabelDefault: 'Apps',
    descriptionId: 'ui-translations.sidebar.stripesApps.description',
    descriptionDefault: 'Override UI app strings',
  },
  {
    tabName: 'permsNames',
    tabLink: '/translations/permsNames',
    Icon: MdVpnKey,
    shortLabelId: 'ui-translations.sidebar.permsNames.shortLabel',
    shortLabelDefault: 'Permissions',
    descriptionId: 'ui-translations.sidebar.permsNames.description',
    descriptionDefault: 'Translate permission names',
  },
];

function RoutesTabs() {
  const currentTab = useCurrentTab();
  const [isExpanded, setIsExpanded] = useState(() => {
    const saved = localStorage.getItem('ui-translations-sidebar-expanded');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem(
      'ui-translations-sidebar-expanded',
      JSON.stringify(isExpanded),
    );
  }, [isExpanded]);

  return (
    <div
      className={`${css.sideMenu} ${isExpanded ? css.expanded : css.collapsed}`}
    >
      <div className={css.expandToggleContainer}>
        <NavListItem
          type="button"
          buttonStyle="slim"
          onClick={() => setIsExpanded(!isExpanded)}
          onMouseDown={(e) => e.preventDefault()}
          className={css.expandToggle}
        >
          {isExpanded ? (
            <MdMenuOpen size={24} className={css.toggleIcon} />
          ) : (
            <MdMenu size={24} className={css.toggleIcon} />
          )}
        </NavListItem>
      </div>

      <div className={css.tabsContainer}>
        {tabs.map((tab) => {
          const tabButton = (
            <NavListItem
              id={`routes-tabs-${tab.tabName}-btn`}
              type="button"
              buttonStyle="slim"
              to={tab.tabLink}
              isActive={currentTab === tab.tabName}
              onMouseDown={(e) => e.preventDefault()}
              className={`${css.tabBtn} ${currentTab === tab.tabName ? css.active : ''}`}
            >
              <div
                className={`${css.tabContent} ${isExpanded ? css.expanded : ''}`}
              >
                <tab.Icon size={24} className={css.tabIcon} />
                {isExpanded && (
                  <span className={css.tabLabelWrapper}>
                    <span className={css.tabLabel}>
                      <FormattedMessage id={tab.shortLabelId} defaultMessage={tab.shortLabelDefault} />
                    </span>
                    <span className={css.tabDescription}>
                      <FormattedMessage id={tab.descriptionId} defaultMessage={tab.descriptionDefault} />
                    </span>
                  </span>
                )}
              </div>
            </NavListItem>
          );

          return !isExpanded ? (
            <Tooltip
              key={tab.tabName}
              id={`routes-tabs-${tab.tabName}-tooltip`}
              text={
                <span>
                  <FormattedMessage id={tab.shortLabelId} defaultMessage={tab.shortLabelDefault} />
                  <br />
                  <span className={css.tooltipDesc}>
                    <FormattedMessage id={tab.descriptionId} defaultMessage={tab.descriptionDefault} />
                  </span>
                </span>
              }
            >
              {({ ref, ariaIds }) => React.cloneElement(tabButton, {
                'aria-labelledby': ariaIds.text,
                ref,
              })}
            </Tooltip>
          ) : (
            <div key={tab.tabName}>{tabButton}</div>
          );
        })}
      </div>
    </div>
  );
}

export default RoutesTabs;
